/** @type {import('../schema').ProcessDefinition} */
const informeGc = {
  id: "informe-gc",
  name: "Informe de gastos comunes",
  category: "finanzas",
  outcome:
    "Reporte del mes con el desglose de gastos por categoría/proveedor.",
  trigger: "El Administrador abre Informe de gastos comunes.",
  actors: ["Administrador", "Sistema"],
  status: "COMPLETO",
  description:
    "Arma el reporte del período con totales por categoría y proveedor, comparativa con el período anterior y exportación.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
  ],
  steps: [
    {
      id: "s1",
      laneId: "admin",
      type: "start",
      label: "Selección de período",
      description: "El Administrador elige el mes a informar.",
      evidence: "src/screens/admin/InformeGastosComunes.jsx",
    },
    {
      id: "s2",
      laneId: "sys",
      type: "task",
      label: "Carga del período",
      description: "Reúne los gastos del mes.",
    },
    {
      id: "s3",
      laneId: "sys",
      type: "decision",
      label: "¿Hay gastos en el período?",
      description:
        "Si no hay gastos, el informe queda vacío.",
    },
    {
      id: "s4",
      laneId: "sys",
      type: "task",
      label: "Desglose",
      description:
        "Totales por categoría y proveedor; comparativa con el período anterior.",
    },
    {
      id: "s5",
      laneId: "admin",
      type: "document",
      label: "Visualización y exportación",
      description: "Visualiza y exporta el informe.",
    },
    {
      id: "s6",
      laneId: "sys",
      type: "end",
      label: "Informe disponible",
    },
    {
      id: "s7",
      laneId: "sys",
      type: "end",
      label: "Informe vacío",
    },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4", label: "Con gastos" },
    { from: "s3", to: "s7", label: "Sin gastos" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6" },
  ],
};
export default informeGc;
